import Spinner from 'react-bootstrap/Spinner';

function LoadingSpinner(minHeight = '200px') {
  return (
    <div
      style={{ minHeight: minHeight }}
      className='d-flex justify-content-center align-items-center'>
      <Spinner variant='light' animation='border' role='status'>
        <span className='visually-hidden'>Loading...</span>
      </Spinner>
    </div>
  );
}

export default LoadingSpinner;
